import React from "react"

import UniversalLink from "../../../../design-system/universal-link"
import { classNames } from "../../../../utils/class-names"
import {
  TREMENDOUS_LINKEDIN_URL,
  TREMENDOUS_TWITTER_URL,
} from "../../../../utils/urls"
import OptimizedImage from "../../../optimized-image"
import * as styles from "./index.module.scss"

interface Props {
  className?: string
}

const Socials = ({ className }: Props) => {
  return (
    <div className={classNames(styles.container, className)}>
      <UniversalLink
        to={TREMENDOUS_TWITTER_URL}
        target="_blank"
        className={styles.socialLink}
      >
        <OptimizedImage
          src="https://www.datocms-assets.com/85985/1703777318-x-logo.png"
          loading="lazy"
          height={22}
          width={22}
          alt="twitter"
          preset="graphic"
        />
      </UniversalLink>
      <UniversalLink
        to={TREMENDOUS_LINKEDIN_URL}
        target="_blank"
        className={styles.socialLink}
      >
        <OptimizedImage
          src="https://www.datocms-assets.com/85985/1698398818-linkedin.png"
          loading="lazy"
          height={22}
          width={22}
          alt="linkedin"
          preset="graphic"
        />
      </UniversalLink>
    </div>
  )
}

export default Socials
